import React, { useState } from 'react';
import Header from '../Components/Header';
import Footer from './Footer';
import './Offers.css';
import { FaSun, FaDollarSign, FaLeaf, FaMapMarkerAlt, FaPhoneAlt, FaTags, FaHandshake } from 'react-icons/fa';

const Offers = () => {
  const [fullName, setFullName] = useState('');
  const [email, setEmail] = useState('');
  const [phone, setPhone] = useState('');
  const [message, setMessage] = useState('');

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      const response = await fetch('https://globalsgtech.com/api/api/offer-form', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ fullName, email, phone, message }), // Added phone
      });
      const result = await response.json();
      if (response.ok) {
        alert('🎉 Offer submitted successfully!');
        setFullName('');
        setEmail('');
        setPhone('');
        setMessage('');
      } else {
        alert('⚠️ ' + result.message);
      }
    } catch (err) {
      console.error(err);
      alert('❌ Failed to submit the offer form.');
    }
  };

  const scrollToForm = () => {
    document.getElementById('offer-form').scrollIntoView({ behavior: 'smooth' });
  };

  return (
    <>
      <Header />

      {/* Hero Section */}
      <section className="offer-hero animate-fade">
        <h1><FaTags className="icon-offer" /> Go Solar & Save More!</h1>
        <p>
          Switch to clean energy today! The <strong>Federal Solar Tax Credit</strong> ends
          <span className="highlight"> Dec 31, 2025</span>.
        </p>
        <button className="cta-button" onClick={scrollToForm}>🚀 Claim Your Discount</button>
      </section>

      {/* Offer Info */}
      <section className="special-offer animate-slide-up">
        <h2>✨ Exclusive Offer</h2>
        <p>
          Contact <strong>Gubendran Lakshmanan</strong> for exclusive offers and assistance.
        </p>
        <div className="contact-box">
          <p>
            <a href="tel:+16468649094">
              <FaPhoneAlt /> +1-646-864-9094
            </a>
          </p>
        </div>
      </section>

      {/* Why Choose Us Section */}
      <section className="why-us animate-slide-up">
        <h2><FaHandshake className="icon" /> Why Choose Us?</h2>
        <div className="why-cards">
          <div className="why-card">
            <h4>💰 Price Match Guarantee</h4>
            <p>Price match guarantee + <strong>10% savings</strong> with price match.</p>
          </div>
          <div className="why-card">
            <h4>📍 Local & Reliable</h4>
            <p>Our company is locally located. Reach us anytime for quick support.</p>
          </div>
        </div>
      </section>

      {/* Form + Benefits */}
      <section className="two-column animate-fade" id="offer-form">
        {/* Left Form */}
        <div className="offer-form">
          <h3>📩 Secure Your Discount</h3>
          <form onSubmit={handleSubmit}>
            <label>Full Name*</label>
            <input type="text" value={fullName} onChange={(e) => setFullName(e.target.value)} required />

            <label>Email*</label>
            <input type="email" value={email} onChange={(e) => setEmail(e.target.value)} required />

            <label>Phone Number*</label>
            <input type="tel" value={phone} onChange={(e) => setPhone(e.target.value)} required />

            <label>Message (Optional)</label>
            <textarea
              value={message}
              onChange={(e) => setMessage(e.target.value)}
              placeholder="E.g. I want to switch to solar, please contact me!"
            />
            <button type="submit" className="submit-btn">✅ Submit Interest</button>
          </form>
        </div>

        {/* Right Benefits */}
        <div className="benefits">
          <h3>🌞 Why Choose Solar?</h3>
          <div className="benefit-card animate-slide-up">
            <FaDollarSign className="icon" />
            <div>
              <h4>Save Money</h4>
              <p>Cut electricity bills & enjoy lifetime energy savings.</p>
            </div>
          </div>
          <div className="benefit-card animate-slide-up delay-1">
            <FaSun className="icon" />
            <div>
              <h4>Tax Benefits</h4>
              <p>Claim federal solar credits before Dec 2025 ends.</p>
            </div>
          </div>
          <div className="benefit-card animate-slide-up delay-2">
            <FaLeaf className="icon" />
            <div>
              <h4>Go Green</h4>
              <p>Help the planet by reducing your carbon footprint.</p>
            </div>
          </div>
        </div>
      </section>

      <Footer />
    </>
  );
};

export default Offers;
